import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const Features = () => (
  <Section id="features">
    <StyledContainer>
      <Subtitle>Features</Subtitle>
      <SectionTitle>Online Archive Explorer</SectionTitle>
      <FeaturesGrid>
        <FeatureItem>
          <FeatureTitle>Upload</FeatureTitle>
          <FeatureText>
            Upload multiple archive files up to 50GB in size.
            Recover your uploading from where you left off
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Recoverable</FeatureTitle>
          <FeatureText>
            Uploads can be recovered for up to 7 days if the network connection is lost.  Just start the upload again and it will pick up where it was lost.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Search your Posts</FeatureTitle>
          <FeatureText>
            Search for content based on post time or content
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Preview and Download</FeatureTitle>
          <FeatureText>
            Preview all your images and videos and download the content your looking for
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Import into Wordpress</FeatureTitle>
          <FeatureText>
            Install the Wordpress plugin and import your content directly into your Wordpress website
          </FeatureText>
        </FeatureItem>
      </FeaturesGrid>
    </StyledContainer>
  </Section>
)

export default Features

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${props => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${props => props.theme.color.accent};
  letter-spacing: 0px;
  margin-bottom: 12px;
  text-align: center;
`

const FeaturesGrid = styled.div`
  max-width: 670px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0px auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
`

const FeatureItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const FeatureTitle = styled.h4`
  color: ${props => props.theme.color.primary};
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 10px;
`

const FeatureText = styled.p`
  text-align: center;
`
